<template>
    <ValidationObserver
        v-slot="{ invalid, passes }"
        tag="form"
        class="sign-up-form"
        @submit.prevent="signUp">
        <GcModal
            v-if="!filledIn"
            condition="true"
            @cancel="$emit('cancel')"
            modal-class="shop-sign-up-modal">

            <template slot="messageTitle">
                <span v-html="$t('actions.shop_sign_up')"></span>
            </template>

            <template slot="body">
                    <transition name="shop-sign-up-modal" mode="out-in">
                        <div class="shop-sign-up-modal__fields" v-if="!sent">
                            <FormTextInput
                                :pretty-name="$t('label.company_name')"
                                :placeholder="$t('placeholders.company_name')"
                                name="company_name"
                                type="text"
                                :initialValue="formData.name"
                                v-model="formData.name"
                                validation-rules="required">
                            </FormTextInput>

                            <FormMultiselectInput
                                :pretty-name="$t('label.industry_vertical')"
                                :placeholder="$t('placeholders.printer')"
                                name="level"
                                validation-rules="required"
                                :options="options.industry_vertical"
                                :initialValue="formData.industry_vertical"
                                v-model="formData.industry_vertical"
                                track-by="value"
                                :tab-fix="true"
                                label="label">
                            </FormMultiselectInput>

                            <FormMultiselectInput
                                :pretty-name="$t('label.shop_owner')"
                                :placeholder="$t('placeholders.printer')"
                                name="shop_owner"
                                validation-rules="required"
                                :options="options.yes_no"
                                track-by="value"
                                label="label"
                                :tab-fix="true"
                                v-model="formData.shop_owner">
                            </FormMultiselectInput>

                            <FormTextInput
                                :pretty-name="$t('label.shop_users_expected')"
                                name="shop_users_expected"
                                type="number"
                                :min="0"
                                v-model="formData.shop_users_expected"
                                validation-rules="required">
                            </FormTextInput>


                            <p class="sign-up-form__terms">
                                {{$t('terms.print_text')}} <a href="/terms" target="_blank">{{$t('terms.link')}}</a>,
                                <a href="/software_terms" target="_blank">{{$t('software_terms.link')}}</a>
                                {{$t('privacy_policy.and')}}
                                <a href="/privacy_policy" target="_blank">{{$t('privacy_policy.link')}}</a> {{$t('privacy_policy.text')}}
                            </p>
                            <p class="shop-sign-up-modal__error" v-if="error">
                                {{error}}
                            </p>
                        </div>

                        <div class="shop-sign-up-modal__sent" v-else>
                            <i class="fas fa-check"></i>
                            <p class="shop-sign-up-modal__sent-text">
                                <a :href="shop_register_success_url" target="_self">Redirecting...</a>
                            </p>
                        </div>
                    </transition>
            </template>

            <template slot="footer">
                <div v-show="!sent && !requestInProgress">
                    <a class="gc-modal__cancel" @click="$emit('cancel')">
                        {{$t('actions.cancel')}}
                    </a>

                    <button class="btn btn__submit" type="submit" :disabled="invalid">
                        {{$t('actions.sign_up_button')}}
                    </button>
                </div>
            </template>
        </GcModal>
    </ValidationObserver>
</template>

<script>
    import FormTextInput from '@/components/shared/inputs/FormTextInput'
    import FormMultiselectInput from '@/components/shared/inputs/FormMultiselectInput'
    import options from '@/components/pages/sign_up/form/form_options'
    import translations from '@/translations/sign_up_form/index'
    import axios from 'axios'

    const SHOP_URL = Grabcad.site.shop;
    const SHOP_REGISTER_SUCCESS_URL = (Grabcad.locale ? `/${Grabcad.locale}` : '') + '/shop/register/success';

    export default {
        name: 'SignUpShop',
        components: {
            FormMultiselectInput,
            FormTextInput
        },
        props: {
            filledIn: Boolean
        },
        data () {
            let industry_vertical
            if (Grabcad.member_company_vertical) {
                industry_vertical = {
                    value: Grabcad.member_company_vertical,
                    label: Grabcad.member_company_vertical
                }
            }
            return {
                sent: false,
                requestInProgress: false,
                error: null,
                options: {
                    industry_vertical: this.getTranslatedOptionWithLabelAndValue('industry_vertical', 'industry_values'),
                    yes_no: this.getTranslatedOptionWithLabelAndValue('yes_no', 'yes_no_values')
                },
                formData: {
                    industry_vertical,
                    name: Grabcad.member_company_name,
                    shop_owner: null,
                    shop_users_expected: ''
                },
                shop_register_success_url: SHOP_REGISTER_SUCCESS_URL,
                shop_url: SHOP_URL
            };
        },
        computed: {
            params () {
                const formData = Object.assign({}, this.formData);

                formData['industry_vertical'] = formData['industry_vertical'].value;
                formData['shop_owner'] = formData['shop_owner'].value;

                return {
                    format: 'json',
                    ...formData
                };
            }
        },

        methods: {
            async signUp () {
                this.requestInProgress = true;
                try {
                    await axios.post('/accounts/create_shop', this.params);
                    this.sent = true;
                    this.error = null;

                    setTimeout(() => {
                        this.$emit('cancel');
                        window.location.href = SHOP_REGISTER_SUCCESS_URL;
                    }, 3000);

                } catch (e) {
                    this.error = 'Something went wrong.';
                } finally {
                    this.requestInProgress = false;
                }
            },
            getTranslatedOptionWithLabelAndValue (optionsKey, translationsKey) {
                const key = translationsKey ? translationsKey : optionsKey;

                return options[optionsKey].map(val => ({
                    value: this.$t(`${key}.${val}`, 'en'),
                    label: this.$t(`${key}.${val}`)
                }));
            }
        },

        mounted () {
            if (this.filledIn) {
                // Set hash to nothing before redirect.
                // Makes sure back button doesn't cause redirect again
                // during automatic trigger of sign up shop modal after login
                window.location.hash = '';
                requestAnimationFrame(() => {
                    window.location.href = SHOP_URL;
                });
            }
        },

        i18n: {
            messages: translations
        }
    }
</script>

<style lang="scss" scoped>
    .gc-modal__cancel {
        font-size: 14px;
        &:hover {
            text-decoration: none;
        }
    }


    .btn__submit {
        border-bottom-width: 1px;
    }
</style>

<style lang="scss">
    @import "styleguidescss/utilities/_variables.scss";
    .shop-sign-up-modal {
        .inline-alert {
            font-size: 14px;
        }

        &.gc-modal-inner {
            max-width: 440px;
            overflow: initial;
            > div:first-child {
                border-top-left-radius: 3px;
                border-top-right-radius: 3px;
            }
            > div:last-child {
                border-bottom-left-radius: 3px;
                border-bottom-right-radius: 3px;
            }
        }
        .gc-modal__header {
            background-color: #333333;
        }

        .gc-modal__message--title {
            font-weight: bold;
            max-width: calc(100% - 30px);
        }

        &__sent {
            padding: 10%;
            text-align: center;
            color: #003393;
            font-size: 30px;
            opacity: 1;

            &-text {
                margin-top: 10px;
                font-size: 16px;
                a {
                    color: lighten(#003393, 10%);
                }
                a:hover {
                    color: inherit;
                    text-decoration: underline;
                }
            }
        }

        &__fields {
            opacity: 1;
        }

        &-enter-active, &-leave-active {
            transition: opacity .5s;
        }

        &-enter, &-leave-to {
            opacity: 0;
        }

        &__error {
            color: $red;
        }
    }
</style>
